import React from 'react'
import { ManufacturerModel } from '../models'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'

interface ManufacturersContextProps {
  manufacturers: ManufacturerModel[]
  loading: boolean
  error?: Error | AuthFetchError
  hasError: boolean
}

/**
 * Context for vehicle manufacturers. Needed for icon urls
 */
export const ManufacturersContext = React.createContext<ManufacturersContextProps | undefined>(undefined)
